import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';

export class footerContents{
	$scope: any = $('.footer-container');
	$accordionID: any = $('#accordion');
	$backToTop: any = $('#back-to--top');

	accordionContent(): void {
		let _self = this;
		if(_self.$scope.length == 0) return
		_self.$scope.find('#accordion.mobile-layout').on('click', '.accordion-toggle', function() {
			//Expand or collapse this panel
			$(this).next().slideToggle('fast');
			$(this).find('.fa').removeClass('fa-angle-down');
			$(this).find('.fa').addClass('fa-angle-up');
			//Hide the other panels
			$('.accordion-content').not($(this).next()).slideUp('fast');
			$('.accordion-content').not($(this).next()).parent().find('.fa').removeClass('fa-angle-up');
			$('.accordion-content').not($(this).next()).parent().find('.fa').addClass('fa-angle-down');
		});

		function resizer(evt: any){
				_self.$accordionID.toggleClass('mobile-layout' , $(window).width() < 767);
				if ($(window).width() >= 767) {
					_self.$accordionID.find('.accordion-content').show();
					evt.preventDefault();
				}
		}
		$(window).on('resize', resizer).resize();
	}

	scrollToTop(): void {
		let _self = this;
		_self.$backToTop.on('click', (e: any) => {
				e.preventDefault();
				$('html,body').animate({
						scrollTop: 0
				}, 700);
		});
	}
}

let scope:Element = document.querySelector('.footer-container');
if (scope){
	try {
		let footercontents = new footerContents();
				footercontents.accordionContent();
				footercontents.scrollToTop();
	} catch(e) {console.error(e);}
}
